<div class="card-container main-font">
  <div class="position-relative">
    <img
      src="assets/images/camillo/camillo-gamification.svg"
      alt="camillo"
      class="img-position" />
    <div class="card-detail mb-2">
      <div class="header-card-detail">
        <div class="lvl-container">
          <p class="text-lvl mb-0">Livello 12</p>
          <div class="pt-container d-flex align-items-center gap-1">
            <img src="assets/images/camillo/camel-coin.svg" alt="" />
            <p class="mb-0 text-pt">1500 Punti</p>
          </div>
        </div>
      </div>
      <div class="position-gamification-container">
        <p class="mb-0 text-position-gamification">26°</p>
      </div>
      <div class="w-100">
        <app-progress-bar-gamification
          [totals]="58"
          [completed]="29"></app-progress-bar-gamification>
      </div>
    </div>
  </div>
</div>
